import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import ContactImage from './contact.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmit(true);

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      payload.append(key, value);
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}mycon/customer_support`, payload
      );
      if (response.data.response === 'success') {
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: ""
        });
        navigate('/thankyou');
      }
      if (response.data.response == 'invalid') {
        setMessage(response.data.message);
      }
    } catch (error) {
      console.error("There was an error While Form Submit!", error);
    } finally {
      setIsSubmit(false);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="contact-page">
      <div className="container contact-page-inner">
        <div className="contact-hero-section text-center">
          <button type="button" className="contact-btn">Contact Us</button>
          <h1 className="contact-title">
            WE ARE HERE TO <span className="highlight">ASSIST YOU</span>
          </h1>
          <p className="contact-subtitle">
            Most Trusted And Premium Matrimony Service In The World.
          </p>
        </div>

        <Row className="contact-info-row g-3 g-md-4">
          <Col xs={12} md={4}>
            <div className="contact-box">
              <h3 className="contact-heading">Contact Us</h3>
              <p className="contact-text">
                For any inquiries, assistance, or feedback related to your experience on:
              </p>
              <ul className="list-unstyled contact-list">
                <li>
                  <FaPhoneAlt className="contact-icon" />
                  <a href="tel:+918088010188">+91 8088010188</a>
                </li>
                <li>
                  <FaEnvelope className="contact-icon" />
                  <a href="mailto:hindusanjog@gmail.com">hindusanjog@gmail.com</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col xs={12} md={8}>
            <div className="info-box">
              <h3 className="info-title">
                Need Any <span className="highlight">Assistance?</span>
              </h3>
              <p>
                Whether you’re seeking support with your profile, need help navigating the platform, or have questions
                regarding our services, our dedicated team is here to help.
              </p>
              <p>
                We aim to provide you with the best matrimonial experience and will respond promptly to ensure all your
                needs are met. Your journey towards finding the perfect match is important to us.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="align-items-center enquiry-form-box g-3 g-md-4">
          <Col md={6} className="d-none d-md-block contact-image-col">
            <img src={ContactImage} alt="Contact Representation" className="contact-side-img" />
          </Col>
          <Col xs={12} md={6}>
            <div className="enquiry-form-inner">
              <h5 className="lets text-center">Let&apos;s Talk</h5>
              <h6 className="sendre text-center">
                Send Your Enquiry <span>Now</span>
              </h6>
              <Form method="post" onSubmit={handleSubmit}>
                <Form.Group controlId="name" className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <input
                    className="holdre"
                    onChange={handleChange}
                    name="name"
                    type="text"
                    value={formData.name}
                    placeholder="Enter your name"
                    required
                  />
                </Form.Group>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <input
                    className="holdre"
                    onChange={handleChange}
                    type="email"
                    name="email"
                    value={formData.email}
                    placeholder="Enter your email"
                    required
                  />
                </Form.Group>
                <Form.Group controlId="phone" className="mb-3">
                  <Form.Label>Phone</Form.Label>
                  <input
                    className="holdre"
                    onChange={handleChange}
                    type="text"
                    name="phone"
                    value={formData.phone}
                    placeholder="Enter your phone"
                    required
                  />
                </Form.Group>
                <Form.Group controlId="message" className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    onChange={handleChange}
                    placeholder="Enter Message"
                    name="message"
                    value={formData.message}
                    className="msekal"
                    as="textarea"
                    rows={3}
                  />
                </Form.Group>
                <Button
                  disabled={isSubmit}
                  className="enquiry-btn w-100 my-2"
                  type={isSubmit ? "button" : "submit"}
                >
                  {isSubmit ? "Sending..." : "Send Enquiry"}
                </Button>
                {message && (
                  <div className="border alert alert-danger">
                    <strong>{message}</strong>
                  </div>
                )}
              </Form>
            </div>
          </Col>
        </Row>
      </div>

      <style>{`
.contact-page {
  background: #fff;
  padding: 96px 0 40px;
  width: 100%;
  box-sizing: border-box;
}

.contact-page *,
.contact-page *::before,
.contact-page *::after {
  box-sizing: border-box;
}

.contact-page-inner {
  max-width: 1140px;
  margin: 0 auto;
  padding-left: 16px;
  padding-right: 16px;
}

.contact-hero-section {
  padding: 8px 0 20px;
}

.contact-btn {
  background-color: #ffecec;
  color: #e91e63;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 14px;
}

.contact-title {
  font-size: clamp(1.35rem, 5vw, 1.85rem);
  font-weight: 700;
  color: #111;
  line-height: 1.3;
  margin: 0 0 8px;
  text-transform: none;
}

.contact-title .highlight,
.info-title .highlight,
.sendre span {
  color: #E53D5C;
  font-weight: 800;
}

.contact-subtitle {
  font-size: 0.95rem;
  color: #555;
  margin: 0 auto;
  max-width: 36rem;
  line-height: 1.45;
}

.contact-info-row {
  margin-bottom: 1.25rem;
}

.contact-box,
.info-box,
.enquiry-form-box {
  background: #fff;
  border: 1px solid #f3d6dc;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.contact-box {
  padding: 1.15rem 1.1rem;
  height: 100%;
}

.contact-heading {
  color: #E53D5C;
  font-weight: 800;
  font-size: 1.2rem;
  margin: 0 0 0.55rem;
}

.contact-text {
  color: #444;
  font-size: 0.92rem;
  line-height: 1.45;
  margin-bottom: 0.85rem;
}

.contact-list {
  margin: 0;
  padding: 0;
}

.contact-list li {
  margin-bottom: 0.7rem;
  font-size: 0.95rem;
  color: #333;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  word-break: break-word;
}

.contact-list a {
  color: #333;
  text-decoration: none;
}

.contact-list a:hover {
  color: #E53D5C;
}

.contact-icon {
  color: #E53D5C;
  flex-shrink: 0;
}

.info-box {
  padding: 1.15rem 1.2rem;
  height: 100%;
  border-color: transparent;
  box-shadow: none;
}

.info-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 0.7rem;
  color: #111;
}

.info-box p {
  color: #555;
  font-size: 0.92rem;
  line-height: 1.55;
  margin-bottom: 0.7rem;
}

.enquiry-form-box {
  margin: 0;
  padding: 1rem;
  overflow: hidden;
}

.contact-side-img {
  width: 100%;
  height: auto;
  max-height: 520px;
  object-fit: cover;
  border-radius: 10px;
  display: block;
}

.enquiry-form-inner {
  padding: 0.35rem 0.25rem;
}

.lets {
  font-size: 1.45rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
}

.sendre {
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 1rem !important;
}

.contact-page .form-label {
  margin-bottom: 0.3rem;
  color: #222;
  font-size: 0.9rem;
  font-weight: 600;
}

.holdre,
.msekal {
  display: block;
  width: 100%;
  padding: 10px 0.75rem;
  font-size: 1rem;
  line-height: 1.45;
  color: #222;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
}

.msekal {
  min-height: 96px;
  resize: vertical;
}

.enquiry-btn {
  background-color: #E53D5C !important;
  border: none !important;
  font-weight: 600;
  padding: 11px 14px;
  border-radius: 10px;
}

.enquiry-btn:hover,
.enquiry-btn:focus {
  background-color: #d63350 !important;
}

@media (max-width: 767.98px) {
  .contact-page {
    padding: 78px 0 28px;
  }

  .contact-page-inner {
    padding-left: 14px;
    padding-right: 14px;
  }

  .contact-hero-section {
    padding: 4px 0 12px;
  }

  .contact-btn {
    font-size: 13px;
    padding: 7px 14px;
    margin-bottom: 10px;
  }

  .contact-title {
    font-size: 1.3rem;
    margin-bottom: 6px;
  }

  .contact-subtitle {
    font-size: 0.88rem;
  }

  .contact-box,
  .info-box {
    padding: 1rem 0.95rem;
  }

  .contact-heading,
  .info-title {
    font-size: 1.1rem;
  }

  .contact-text,
  .info-box p,
  .contact-list li {
    font-size: 0.88rem;
  }

  .enquiry-form-box {
    padding: 0.85rem 0.75rem 1rem;
  }

  .lets {
    font-size: 1.25rem;
  }

  .sendre {
    font-size: 0.95rem;
    margin-bottom: 0.85rem !important;
  }

  .holdre,
  .msekal {
    font-size: 0.95rem;
    padding: 10px 12px;
  }
}

@media (min-width: 768px) {
  .contact-page {
    padding: 110px 0 48px;
  }

  .info-box {
    padding-left: 1.5rem;
  }

  .enquiry-form-box {
    padding: 1.25rem;
  }
}
`}</style>
    </div>
  );
};

export default Contact;
